<div class="n-primeiro-acesso">
  <div class="n-header">
    <img
      src="logo.png"
      alt="Logo Bardo"
      class="n-logo n-logo-clickable"
      width="150"
      height="50"
      loading="eager"
      decoding="async"
      (click)="navegarHome()"
      role="link"
      tabindex="0"
      (keydown.enter)="navegarHome()"
    />
  </div>

  <div class="n-main-container">
    <div class="n-welcome-container">
      <div class="n-welcome-content n-animate-slideInLeft">
        <div class="n-welcome-badge">
          <i class="pi pi-sparkles n-icon"></i>
          {{ 'PRIMEIRO_ACESSO.BADGE' | translate }}
        </div>

        <h1 class="n-welcome-title">
          {{ 'PRIMEIRO_ACESSO.TITULO_PREFIXO' | translate }} <span class="n-highlight">{{ 'PRIMEIRO_ACESSO.TITULO_DESTAQUE' | translate }}</span>
        </h1>

        <p class="n-welcome-description">
          {{ 'PRIMEIRO_ACESSO.DESCRICAO' | translate }}
        </p>

        <ul class="n-features-list">
          <li>
            <span class="n-check-icon"></span>
            {{ 'PRIMEIRO_ACESSO.BENEFICIO_1' | translate }}
          </li>
          <li>
            <span class="n-check-icon"></span>
            {{ 'PRIMEIRO_ACESSO.BENEFICIO_2' | translate }}
          </li>
          <li>
            <span class="n-check-icon"></span>
            {{ 'PRIMEIRO_ACESSO.BENEFICIO_3' | translate }}
          </li>
        </ul>
      </div>

      <div class="n-form-container n-animate-slideInRight">
        <div class="n-form-header">
          <h2 class="n-form-title">{{ 'PRIMEIRO_ACESSO.TITULO_FORM' | translate }}</h2>
          <p class="n-form-subtitle">
            {{ 'PRIMEIRO_ACESSO.SUBTITULO_FORM' | translate }}
          </p>
        </div>

        @if (finalizando()) {
          <div class="n-primeiro-acesso-loading">
            <p>{{ 'PRIMEIRO_ACESSO.CARREGANDO' | translate }}</p>
          </div>
        } @else {
          <lib-etapa-estabelecimento
            (proximaEtapa)="onEstabelecimentoSalvo()"
          />
        }
      </div>
    </div>
  </div>
</div>
